import { Engine } from '../../core/Engine';
import { MoveLayerCommand } from '../Commands';

export class MoveLayerCommandHandler {
    private engine: Engine;

    constructor(engine: Engine) {
        this.engine = engine;
    }

    handle(command: MoveLayerCommand) {
        this.engine.moveLayer(command.uuid, command.layer);
    }
}
